export default __webpack_public_path__ + "static/media/img-6.b0b6b01a.jpg";